import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class ServiceStatus extends ModelBase {
  public static readonly type = 'ServiceStatus';

  @autoserializeAs('has_message')
  public hasMessage: boolean;

  @autoserializeAs('title')
  public title: string;

  @autoserializeAs('message')
  public message: string;

  @autoserializeAs('quit')
  public quit: boolean;
}
